































































import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { mapMutations, mapGetters, mapActions } from 'vuex';
import { CatalogItem, CatalogV1StageListRequest, StageImageResponse } from '@/requests/mainApi';
import { iconsMixin } from '@/components/ui/UiIcons/iconsPropsMixin';
import { mainSiteLink } from '@/utils/plugins/links';
import { storeModuleName } from '@/store/modules/ui';

interface Data {
  reportLink: string;
  selectedPictureIndex: number;
  viewingImages: boolean;
  constructionStages: StageImageResponse[];
}

interface Methods {
  analyticsSend: () => void;
  setSelectedPicture: (picture: string) => void;
  setPicturesInGallery: (pictures: Array<string>) => void;
  setCurrentGalleryPicture: (index: number) => void;
  setPPDAndTPDConfirmModalOpen: (state: boolean) => void;
  setFlatDocumentsModalOpen: (state: boolean) => void;
  setCurrentObjectDocs: (state: { uuid: string; name: string; date: string }) => void;
  showImages: () => void;
  getConstructionStages: (payload: CatalogV1StageListRequest) => Promise<StageImageResponse[]>;
}

interface Computed {
  selectedPicture: string;
  currentGalleryPicture: number;
  isReadyToKeyGetting: boolean;
}

interface Props {
  flatModel: CatalogItem;
}

export default Vue.extend({
  name: 'LongFlatCard',
  mixins: [iconsMixin],
  props: {
    flatModel: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      reportLink: `${mainSiteLink}?openform=contact`,
      selectedPictureIndex: 0,
      viewingImages: false,
      constructionStages: [],
    };
  },
  watch: {
    currentGalleryPicture(val: number) {
      if (val === -1) {
        this.viewingImages = false;
        return;
      }
      if (this.viewingImages) {
        this.selectedPictureIndex = val;
      }
    },
  },
  computed: {
    selectedPicture() {
      return this.flatModel.planImages ? this.flatModel.planImages[this.selectedPictureIndex] : '';
    },
    isReadyToKeyGetting() {
      const { statusBazis, buildingState } = this.flatModel;

      return buildingState === 'Сдан' && [2, 4, 5, 6, 11, 12].includes(statusBazis?.id);
    },
    ...mapGetters(storeModuleName, ['currentGalleryPicture']),
  },
  destroyed() {
    this.setCurrentGalleryPicture(0);
  },
  methods: {
    analyticsSend() {
      this.$analytics.logEvent('get_help', {
        screen: this.$route.meta.analyticsName,
      });
    },
    setSelectedPicture(picture: string) {
      this.selectedPictureIndex = this.flatModel.planImages!.indexOf(picture);
      this.setCurrentGalleryPicture(this.selectedPictureIndex);
    },
    showImages() {
      this.setPicturesInGallery(this.flatModel.planImages!);
      this.setCurrentGalleryPicture(this.selectedPictureIndex);
      this.viewingImages = true;
    },
    ...mapMutations(storeModuleName, ['setPicturesInGallery', 'setCurrentGalleryPicture']),
    ...mapMutations([
      'setPPDAndTPDConfirmModalOpen',
      'setFlatDocumentsModalOpen',
      'setApartmentAcceptanceModalOpened',
      'setApartmentAcceptanceFlatModel',
      'setCurrentObjectDocs'
    ]),
    ...mapActions(['getConstructionStages']),
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
